"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var SelfReflection = /*#__PURE__*/function () {
  function SelfReflection(client) {
    (0, _classCallCheck2["default"])(this, SelfReflection);
    this.client = client;
    this.resourceUrl = '/self-reflection';
  }

  (0, _createClass2["default"])(SelfReflection, [{
    key: "unsubscribeEmail",
    value: function unsubscribeEmail(params) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return this.client.post("".concat(this.resourceUrl, "/email/unsubscribe").concat(params), args);
    }
  }]);
  return SelfReflection;
}();

exports["default"] = SelfReflection;